import { TimeFrame } from "charts/src/types/chart";

import { DateOption } from "@/utils/date-options";

export const dateOptions: DateOption[] = ["3Y", "5Y", "10Y"];

export const getDefaultDateOption = (timeFrame: TimeFrame): DateOption => {
  switch (timeFrame) {
    case "Q":
      return "3Y";
    case "4Q":
      return "3Y";
    case "Y":
      return "10Y";
    default:
      return "3Y";
  }
};
